import styled, { css } from 'styled-components';

import { COLORS, MOBILE, GRADIENTS } from '../../theme/tokens';

export type PanelVariant = 'warm' | 'cool' | 'plain';

const VARIANT_BG: Record<PanelVariant, ReturnType<typeof css>> = {
  warm: css`
    background: ${GRADIENTS.warm};
  `,
  cool: css`
    background: ${GRADIENTS.cool};
  `,
  plain: css`
    background: ${COLORS.surfaceCard};
  `,
};

export const Root = styled.div<{ $variant: PanelVariant }>`
  border-radius: 20px;
  padding: 24px 26px;
  box-sizing: border-box;
  ${(p) => VARIANT_BG[p.$variant]}
  ${MOBILE} {
    padding: 20px 16px;
  }
`;